import { render } from "./MemberCardShow.vue?vue&type=template&id=8a417050&scoped=true"
import script from "./MemberCardShow.vue?vue&type=script&lang=js"
export * from "./MemberCardShow.vue?vue&type=script&lang=js"

import "./MemberCardShow.vue?vue&type=style&index=0&id=8a417050&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a417050"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/MemberCardShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a417050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a417050', __exports__)) {
    api.reload('8a417050', __exports__)
  }
  
  module.hot.accept("./MemberCardShow.vue?vue&type=template&id=8a417050&scoped=true", () => {
    api.rerender('8a417050', render)
  })

}


export default __exports__